export default __webpack_public_path__ + "static/media/basketball-active.6068095d.webp";